import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class TextBoxUi extends Plugin {
    init() {}
}
